var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#8C62FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6855 12.7991C28.6495 12.5412 28.464 12.3291 28.2132 12.2594L20.1749 10.0239C20.0603 9.99203 19.9392 9.99203 19.8245 10.0239L11.7862 12.2594C11.5354 12.3291 11.3499 12.5411 11.314 12.7991C11.2673 13.1343 10.2037 21.0556 12.9318 24.9961C15.6567 28.932 19.6765 29.9406 19.8462 29.9817C19.8967 29.9939 19.9481 29.9999 19.9997 29.9999C20.0513 29.9999 20.1027 29.9938 20.1532 29.9817C20.323 29.9406 24.3428 28.932 27.0676 24.9961C29.7957 21.0556 28.7321 13.1344 28.6855 12.7991ZM25.1834 17.4236L19.7004 22.9065C19.5729 23.0341 19.4055 23.098 19.2383 23.098C19.0711 23.098 18.9038 23.0342 18.7762 22.9065L15.3861 19.5165C15.2635 19.3939 15.1946 19.2277 15.1946 19.0543C15.1946 18.881 15.2636 18.7147 15.3861 18.5922L16.0592 17.9191C16.3145 17.6639 16.7283 17.6638 16.9835 17.9191L19.2383 20.1739L23.586 15.8261C23.7085 15.7035 23.8748 15.6346 24.0482 15.6346C24.2215 15.6346 24.3878 15.7035 24.5103 15.8261L25.1834 16.4992C25.4387 16.7545 25.4387 17.1683 25.1834 17.4236Z",
    fill: "#8C62FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasement);
export default __webpack_public_path__ + "static/media/Basement.0707def809f824ca6c61300e5a7a3a68.svg";
export { ForwardRef as ReactComponent };